"use client";

import { AnimatePresence } from "motion/react";
import * as m from "motion/react-m";

export function RecordingPrompts({
  prompts,
  promptIndex,
}: {
  prompts: { direction: string; text: string }[];
  promptIndex: number;
}) {
  return (
    <div className='tw-text-center tw-mx-auto tw-max-w-md'>
      <AnimatePresence mode='wait'>
        <m.div
          key={promptIndex}
          initial={{ opacity: 0, filter: "blur(8px)" }}
          animate={{ opacity: 1, filter: "blur(0px)" }}
          exit={{ opacity: 0, filter: "blur(8px)" }}
          transition={{ duration: 0.3 }}
          className='tw-flex tw-flex-col tw-items-center tw-gap-0.5'
        >
          <p className='tw-text-black tw-text-sm tw-font-medium'>{prompts[promptIndex].direction}</p>
          {prompts[promptIndex].text && (
            <p className='tw-text-gray-600 tw-text-sm tw-leading-snug'>&quot;{prompts[promptIndex].text}&quot;</p>
          )}
        </m.div>
      </AnimatePresence>
    </div>
  );
}
